module.exports = __webpack_public_path__ + "img/medalha-govtech.382eaa18.jpeg";